import React from "react";

function Tooltip({ details, position }: { details: string[]; position: string }) {
  return (
    <div>
      <div className="tooltip_container">
        <ul>
          {details.map((detail, index) => (
            <li key={index}>{detail}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Tooltip;
